var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.05.25a.75.75 0 0 1 .681.436l2.236 4.848 5.303.63a.75.75 0 0 1 .42 1.295l-3.92 3.625 1.041 5.237a.75.75 0 0 1-1.102.8L9.05 14.515l-4.66 2.608a.75.75 0 0 1-1.101-.801l1.04-5.237L.41 7.459a.75.75 0 0 1 .42-1.296l5.303-.629L8.369.686A.75.75 0 0 1 9.05.25Zm0 2.54L7.319 6.545a.75.75 0 0 1-.593.43l-4.105.487 3.035 2.807a.75.75 0 0 1 .227.696l-.806 4.054L8.684 13a.75.75 0 0 1 .732 0l3.607 2.018-.806-4.054a.75.75 0 0 1 .227-.696l3.035-2.807-4.105-.486a.75.75 0 0 1-.593-.431L9.05 2.79Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.98530165830f556e7a4df8b62acc18b2.svg";
export { ForwardRef as ReactComponent };